/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

const IntentionTypes = {
  GETTING_READY: 'Getting Ready',
  DEVELOPMENT: 'Development',
  ACCEPTING: 'Accepting',
  SHIPPING: 'Shipping',
  DEPLOYING: 'Deploying'
};

export default IntentionTypes;
